module.exports = __webpack_public_path__ + "media/images/heart-a1cc67678cdf7dc9e551b1fb8bd27a5b.svg";